export const FIGURE = "FIGURE";
export const TRACK = "TRACK";
export const PATTERN = "PATTERN";
